module.exports = __webpack_public_path__ + "img/56.7170d522.jpg";